import Layout from "@quint/components/layout";
import { Button } from "@quint/ui";
import Image from "next/image";
import { useRouter } from "next/router";

import img404 from "public/images/404.png";

export default function Custom404() {
  const router = useRouter();

  return (
    <Layout>
      <div className="x-padding my-[72px] flex flex-col items-center justify-center gap-10">
        <Image src={img404} alt="404"  priority loading="eager" />
        <div className="flex max-w-[594px] flex-col items-center justify-center gap-6">
          <h1 className="text-center font-satoshi text-[64px] font-bold leading-[72px] tracking-tight">
            Oops! Looks like you took a wrong turn
          </h1>
          <p className="text-center font-inter text-[22px] font-normal leading-[30px] text-[#677680] dark:text-[#B3BAC0]">
            {`But don't worry, we're here to help you find your way back to the right page`}
          </p>
          <Button variant="primaryGradient" className="w-fit" onClick={() => router.back()}>
            GO BACK
          </Button>
        </div>
      </div>
    </Layout>
  );
}
